export const checkBusinessCode = (code) => {
  const regex = /^(?=[0-9]*[-][0-9]*$)[0-9-]+$/g //accept only 0-9 and one character '-'
  if (code.match(regex)) {
    return true
  }
  return false
}
